module.exports = __webpack_public_path__ + "static/img/jl-drgs.89ad268.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/jl-drgs.png
// module id = fLhJ
// module chunks = 1